import "./App.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import { ProtectedRoute } from "./utils/ProtectedRoute";
import HabitGraph from "./pages/HabitGraph";
import VerificationLink from "./components/VerificationLink";
import NotFound from "./components/404";
import Diary from "./components/Diary";
import DiaryPage from "./components/DiaryPage";
import LandingPage from "./components/LandingPage";

function App() {
  return (
    <>
      <Router>
        <Switch>
          <Route exact component={Register} path="/register" />
          <Route exact component={Login} path="/login" />
          <Route exact component={LandingPage} path="/" />

          <ProtectedRoute component={Profile} path="/me" />
          <ProtectedRoute exact component={Home} path="/home" />
          <ProtectedRoute exact component={HabitGraph} path="/graph/:id" />
          <ProtectedRoute exact component={DiaryPage} path="/diary-new-entry" />
          <ProtectedRoute exact component={Diary} path="/diary" />

        </Switch>
      </Router>
    </>
  );
}

export default App;

//https://coolors.co/333333-48e5c2-fcfaf9-f3d3bd-5e5e5e
